(() => {
  function setup(root) {
    root.querySelectorAll('[data-mc-newsletter]').forEach(section => {
      if (section.dataset.mcReady) return;
      section.dataset.mcReady = 'true';
      const form = section.querySelector('.mc-newsletter__form');
      const update = () => {
        const input = form.querySelector('input[type="email"]');
        const button = form.querySelector('button.klaviyo-form-button[data-action-id]');
        if (input) {
          if (input.placeholder !== section.dataset.emailLabel) input.placeholder = section.dataset.emailLabel;
          if (input.getAttribute('aria-label') !== section.dataset.emailLabel) input.setAttribute('aria-label', section.dataset.emailLabel);
          const label = section.querySelector('.mc-newsletter__label');
          if (input.id && label.htmlFor !== input.id) label.htmlFor = input.id;
        }
        if (input && button && button.getAttribute('aria-busy') !== 'true' && !button.disabled && button.textContent !== section.dataset.buttonLabel) button.textContent = section.dataset.buttonLabel;
      };
      update();
      new MutationObserver(update).observe(form, {childList:true,subtree:true});
    });
  }
  setup(document);
  document.addEventListener('shopify:section:load', () => setup(document));
})();
